<template>
  <div>
    <v-data-table
      style="margin-top: 0;margin-left:5px;margin-right:5px;"
      :headers="headers"
      :items="devices"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:[`item.Serial`]="{ item }">
        <!-- <span v-if="isDevelopment" @click="() => handleEditDescription(item.id)">{{ item.name }}</span> -->
        <!--description-form  :key="`inci_${item.serial}`" v-if="isEditDescription" :item="item" /-->
        <span style="cursor:pointer;font-family: RobotoMonoMedium !important;" @click="() => { onSelectedDetailsDevice(item)}">{{ item.Serial }}</span>
        <v-icon v-if="!readonly" small style="margin-left: 5px;" color="gray" @click="() => { handleCopy(item.Serial)}">mdi-content-copy</v-icon>
      </template>
      <template v-slot:[`item.Uptime`]="{ item }">
        <!-- <span v-if="isDevelopment" @click="() => handleEditDescription(item.id)">{{ item.name }}</span> -->
        <!--description-form  :key="`inci_${item.serial}`" v-if="isEditDescription" :item="item" /-->
        <div v-if="item.UptimeError && item.Status === 'Normal'">
          <v-icon style="color:red;margin-right: 5px;">mdi-heart-pulse</v-icon><span style="color: red;">{{ item.Uptime}}</span>
        </div>
      </template>
      <template v-slot:[`item.Name`]="{ item }">
        <v-tooltip bottom v-if="item.Description && item.Description.length > 1">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              @click="() => { onSelectedDetailsDevice(item)}"
              style="cursor:pointer;"
            >{{item.Name}}</span>
          </template>
          <span>{{item.Description}}</span>
        </v-tooltip>
        <span v-else @click="() => { onSelectedDetailsDevice(item)}">{{ item.Name}}</span>
      </template>
      <template v-slot:[`item.focus`]="{ item }">
        <v-icon small @click="handleFocus(item)" :color="item.focus ? 'green' : 'gray'">{{ !item.focus ? 'mdi-pin' : 'mdi-pin-off' }}</v-icon>
        <v-icon v-if="onSyncDevice" small @click="onSyncDevice(item)" color="gray">mdi-sync</v-icon>
      </template>
      <template v-slot:[`item.icons`]="{ item }">
        <v-icon small style="margin-right: 5px;" :color="item.WirelessEnabled || !item.WiredDHCP ? 'green' : 'gray'" @click="() => { onSelectedNetworkConfig(item) }">mdi-network-outline</v-icon>
        <v-icon small style="margin-right: 5px;" :color="item.Snapshot ? 'green' : 'gray'" @click="() => { onSelectedScreenshotDevice(item) }">mdi-camera</v-icon>
        <v-icon small style="margin-right: 5px;" :color="item.WithNotes ? 'green' : 'gray'" @click="() => { onSelectedNotesDevice(item)}">mdi-note-edit</v-icon>
        <v-tooltip bottom v-if="item.Incremental && item.Incremental > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              :color="item.Incremental ? 'green' : 'gray'" 
              v-bind="attrs"
              v-on="on"
              @click="() => { onSelectedIncrementalDevice(item)}"
              style="cursor:pointer;"
            >
              mdi-numeric-9-plus-box-multiple
            </v-icon>
          </template>
          <span>{{item.Incremental}}</span>
        </v-tooltip>
        <v-icon v-else small style="margin-right: 5px;cursor:pointer;" color="gray" @click="() => { onSelectedIncrementalDevice(item)}">mdi-numeric-9-plus-box-multiple</v-icon>
      </template>
      <template v-slot:[`item.Network`]="{ item }">
        <!--v-chip style="width:100%" small :color="getColor(item.Network)" dark><center style="width=100%">{{ item.Network }}</center></v-chip-->
        <div @click="onSelectNetwork ? onSelectNetwork(item.Network) : null" style="cursor:pointer;width:100%;text-align:center; border-radius:25px; padding: 5px;color: white;" small :style="{ backgroundColor: getColor(item.Network)}" dark>{{ item.Network }}</div>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        <div style="cursor:pointer;font-weight: 700;" @click="() => { onSelectedErrorDeviceID(item) }">
          <small :style="{ color: item.Status === 'Error' ? '#D32F2F' : item.Status === 'Normal' ? 'green'  : item.Status === 'Warning' ? 'orange'  : 'gray'}" >{{ item.Status ? item.Status.toUpperCase() : '' }}</small>
        </div>
      </template>
      <!--template v-slot:[`item.letime`]="{ item }">
        <div style="width:150px">
          {{convertTime(item.letime)}}
        </div>
      </template>
      <template v-slot:[`item.lctime`]="{ item }">
        <div style="width:150px">
          {{convertTime(item.lctime)}}
        </div>
      </template-->
      
    </v-data-table>
  </div>
</template>

<script>
  import axios from 'axios'
  import utils from '@/services/utils'
  export default {
    name: 'Brightsignnetwork',
    props: {
      onSelectNetwork: {
        type: Function,
        default: null,
      },
      readonly: {
        type: Boolean,
        default: true,
      },
      selectedHeaderCols: {
        type: Array,
        default: null,
      },
      devices: {
        type: Array,
        required: true,
      },
      onFocus: {
        type: Function,
        required: true
      },
      onSelectedErrorDeviceID: {
        type: Function,
        required: true
      },
      onSelectedNetworkConfig: {
        type: Function,
        required: true
      },
      onSelectedIncrementalDevice: {
        type: Function,
        required: true
      },
      onSelectedNotesDevice: {
        type: Function,
        required: true
      },
      onSelectedDetailsDevice: {
        type: Function,
        required: true
      },
      onSelectedScreenshotDevice: {
        type: Function,
        required: true
      },
      onSyncDevice: {
        type: Function,
        default: null,
      },
    },
    data: () => ({
      headers: [],
    }),
    computed: {
      headers_ () {
        if (this.readonly) {
          return [
            {
              text: 'Network',
              align: 'start',
              value: 'Network',
            },
            //Baobad_Guest
            { text: 'Unit ID', value: 'Serial' },
            { text: 'Nombre', value: 'Name' },
            { text: 'Model', value: 'Model' }, 
            { text: 'Firmware', value: 'Firmware', align: 'center' },
            { text: '', value: 'icons' }, 
            { text: 'LastHeartbeatTime', value: 'LastHeartbeatTime', sortable: false }, 
            { text: 'Uptime', value: 'Uptime' },
            { text: 'Status', value: 'Status', align: 'center', sortable: false },
            /*
            { text: 'Fecha / Hora últ con', value: 'lctime' },
            { text: 'Fecha / Hora últ error', value: 'letime' },
            { text: 'Días Error', value: 'diffErrorTime' },
            */
          ]
        } else {
          return [
            { text: '', value: 'focus' },
            {
              text: 'Network',
              align: 'start',
              value: 'Network',
            },
            //Baobad_Guest
            { text: 'Unit ID', value: 'Serial' },
            { text: 'Nombre', value: 'Name' },
            { text: 'Model', value: 'Model' }, 
            { text: 'Firmware', value: 'Firmware', align: 'center' },
            { text: '', value: 'icons' }, 
            { text: 'LastHeartbeatTime', value: 'LastHeartbeatTime', sortable: false }, 
            { text: 'Uptime', value: 'Uptime' },
            { text: 'Status', value: 'Status', align: 'center', sortable: false },
            /*
            { text: 'Fecha / Hora últ con', value: 'lctime' },
            { text: 'Fecha / Hora últ error', value: 'letime' },
            { text: 'Días Error', value: 'diffErrorTime' },
            */
          ]
        }
      },
    },
    watch: {
      selectedHeaderCols () {
        this.prepareHeader()
      },
    },
    mounted () {
      this.prepareHeader()
    },
    methods: {
      getColor (value) {
        return utils.getColor(value)
      },
      convertTime(v) {
        const dt = new Date(v)
        const result = `${
                dt.getDate().toString().padStart(2, '0')}/${
                (dt.getMonth()+1).toString().padStart(2, '0')}/${
                dt.getFullYear().toString().padStart(4, '0')} ${
                dt.getHours().toString().padStart(2, '0')}:${
                dt.getMinutes().toString().padStart(2, '0')}:${
                dt.getSeconds().toString().padStart(2, '0')}`

        return result === '01/01/0001 00:00:00' || result === '01/01/2001 00:00:00' ? '' : result
      },
      prepareHeader () {
        if (this.readonly) {
          this.headers = [
            { text: 'Network', align: 'start', value: 'Network', sortable: false },
            { text: 'Unit ID', value: 'Serial', sortable: false },
            { text: 'Nombre', value: 'Name', sortable: false },
            { text: 'Model', value: 'Model', sortable: false }, 
            { text: 'Firmware', value: 'Firmware', align: 'center', sortable: false },
            { text: '', value: 'icons', sortable: false }, 
            { text: 'LastHeartbeatTime', value: 'LastHeartbeatTime', sortable: false }, 
            { text: 'Uptime', value: 'Uptime', sortable: false },
            { text: 'Status', value: 'Status', align: 'center', sortable: false },
          ]
        } else if (!this.selectedHeaderCols) {
          this.headers = [
            { text: '', value: 'focus', sortable: false },
            { text: 'Network', align: 'start', value: 'Network', sortable: false },
            { text: 'Unit ID', value: 'Serial', sortable: false },
            { text: 'Nombre', value: 'Name', sortable: false },
            { text: 'Model', value: 'Model', sortable: false }, 
            { text: 'Firmware', value: 'Firmware', align: 'center', sortable: false },
            { text: '', value: 'icons', sortable: false }, 
            { text: 'LastHeartbeatTime', value: 'LastHeartbeatTime', sortable: false }, 
            { text: 'Uptime', value: 'Uptime', sortable: false },
            { text: 'Status', value: 'Status', align: 'center', sortable: false },
          ]
        } else {
          const aux = {
            focus: { text: '', value: 'focus', sortable: false },
            Network: { text: 'Network', align: 'start', value: 'Network', sortable: false },
            Serial: { text: 'Unit ID', value: 'Serial', sortable: false },
            Name: { text: 'Nombre', value: 'Name', sortable: false },
            Model: { text: 'Model', value: 'Model', sortable: false }, 
            Firmware: { text: 'Firmware', value: 'Firmware', align: 'center', sortable: false },
            icons: { text: '', value: 'icons', sortable: false }, 
            LastHeartbeatTime: { text: 'LastHeartbeatTime', value: 'LastHeartbeatTime', sortable: false }, 
            Uptime: { text: 'Uptime', value: 'Uptime', sortable: false },
            Status: { text: 'Status', value: 'Status', align: 'center', sortable: false },
          }
          this.headers = this.selectedHeaderCols.map(item => {
            if (aux[item]) return aux[item]
            else return { text: item, value: item, sortable: false }
          })
        }
      },
      handleFocus (v) {
        this.onFocus(v)
      },
      handleCopy (v) {
          // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        if (window.clipboardData && window.clipboardData.setData) return window.clipboardData.setData('Text', v)
        else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
          var textarea = document.createElement('textarea')
          textarea.textContent = v
          textarea.style.position = 'fixed'  // Prevent scrolling to bottom of page in Microsoft Edge.
          document.body.appendChild(textarea)
          textarea.select()
          try {
            return document.execCommand('copy')  // Security exception may be thrown by some browsers.
          } catch (ex) {
            console.warn('Copy to clipboard failed.', ex)
            return prompt('Copy to clipboard: Ctrl+C, Enter', v)
          } finally {
            document.body.removeChild(textarea)
          }
        }
      },
    },
  }
</script>

<style scoped>
  .main {
    position: absolute;
    background-color: rgba(237, 237, 237);
    width: 1920px;
    min-height: calc(100vh);
  }
  .col-left {
    position: relative;
    width: 610px;
  }
  .col-right {
    position: relative;
    width: 1310px;
  }
  .card-header {
    background-color: #90A4AE;
    color: white;
    font-size: 25px;
    padding: 10px 0;
  }
</style>
